import React from 'react'
import { useTranslation } from 'react-i18next'
import { DmcResponsiveCheckboxTable } from '../../common/DmcResponsiveTable'
import GroupReservationRow from './GroupReservationRow'

export default function GroupReservationsTable({ setCheckedRanIds, reservations, personData, userNames }) {
  const { t } = useTranslation()
  return (
    <DmcResponsiveCheckboxTable
      id="Group Reservations"
      onSelectionChange={setCheckedRanIds}
      totalColumnCount={9}
      separator={
        <>
          <br />
          <br />
        </>
      }
      atSizeColumns={{
        default: {
          labels: [
            t('person.label', 'Person'),
            t('reservations.ordinance', 'Ord'),
            t('reservations.ownerAssignedTo', 'Owner/Assigned'),
            t('reservations.reservedAssigned', 'Reserved/Assigned'),
            t('reservations.printedExpired', 'Printed/Expires'),
            t('reservations.ranId', 'RAN ID'),
          ],
          columnWidths: [3, 1, 2, 2, 2, 2],
          combinationRules: [
            ['column1'],
            ['column2'],
            ['column3', 'column4'],
            ['column5', 'column6'],
            ['column7', 'column8'],
            ['column9'],
          ],
        },
        sm: {
          labels: [
            t('person.label', 'Person'),
            t('reservations.ordinanceOwnerAssigned', 'Ordinance/ Owner/ Assigned'),
            t('reservations.reservedAssignedPrintedExpires', 'Reserved/ Assigned/ Printed/ Expires'),
            t('reservations.ranId', 'RAN ID'),
          ],
          columnWidths: [3, 3, 3, 3],
          combinationRules: [
            ['column1'],
            ['column2', 'column3', 'column4'],
            ['column5', 'column6', 'column7', 'column8'],
            ['column9'],
          ],
        },
        xl: {
          labels: [
            t('person.label', 'Person'),
            t('reservations.ordinance', 'Ord'),
            t('reservations.ownerAssignedTo', 'Owner/Assigned'),
            t('reservations.reservedAssigned', 'Reserved/Assigned'),
            t('reservations.printedExpired', 'Printed/Expires'),
            t('reservations.ranId', 'RAN ID'),
          ],
          columnWidths: [3, 1, 2, 2, 2, 2],
          combinationRules: [
            ['column1'],
            ['column2'],
            ['column3', 'column4'],
            ['column5', 'column6'],
            ['column7', 'column8'],
            ['column9'],
          ],
        },
      }}
    >
      {reservations.map((reservation) => {
        return (
          <GroupReservationRow
            key={reservation.decodedRanId}
            personData={personData}
            reservation={reservation}
            userNames={userNames}
          />
        )
      })}
    </DmcResponsiveCheckboxTable>
  )
}
